/**
 * Сhecks the string can be an email
 * @param value: string
 * @returns boolean - is the value an email
 */
export const validateEmail = (value: string): boolean => {
  if (value.length > 320 || value.length < 7) return false;
  const parts = value.split('@');
  if (!parts || parts.length < 2 || parts[0].length > 63 || parts[1].length > 255) return false;

  const regex =
    // eslint-disable-next-line no-useless-escape
    /^(([^а-яА-Я<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Zа-яА-Я_\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/;
  return regex.test(value);
};
